import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";
import { API_ENDPOINT } from "./Api";

let env = process.env.REACT_APP_B2B_API_BASE_URL

export const  rideDetailsApi = async(data) => {
  const url = `${env}${API_ENDPOINT.Dashboard.rideDetailsApi+'?companyId='+(data?.companyId?data?.companyId:'')+"&dateFrom="+data?.dateFrom+"&dateTo="+data?.dateTo}`

  const res = await requestInstance.get(
    url
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}
